import { gql, LazyQueryHookOptions, TypedDocumentNode, useLazyQuery } from "@apollo/client";

import { caseSummaryFragment } from "src/graphql/anti-fraud/fragments/CaseSummaryFragment";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

import { TestRuleQuery, TestRuleQueryVariables } from "../../__generated__/graphql";

export const testRuleQuery = gql`
  query TestRule($input: TestRuleRequest!) {
    testRule(input: $input) {
      relatedCases {
        ...CaseSummaryFragment
      }
      matched
      caseInfo {
        ...CaseSummaryFragment
      }
      rule {
        ...RuleFragment
      }
    }
  }

  ${caseSummaryFragment}
  ${ruleFragment}
` as TypedDocumentNode<TestRuleQuery, TestRuleQueryVariables>;

export const useLazyTestRuleQuery = (
  options?: LazyQueryHookOptions<TestRuleQuery, TestRuleQueryVariables>
) => {
  return useLazyQuery(testRuleQuery, options);
};
